const waiters = [];
let activeTicket = null;

function removeWaiter(ticket) {
  const index = waiters.indexOf(ticket);
  if (index >= 0) waiters.splice(index, 1);
}

function grantNext() {
  if (activeTicket) return;
  while (waiters.length) {
    const ticket = waiters.shift();
    if (ticket.cancelled) continue;
    activeTicket = ticket;
    ticket.granted = true;
    ticket.resolve(true);
    return;
  }
}

/**
 * A fair, app-wide permit shared by standard and damage image queues.
 * Cancellation settles waiting jobs as false, which is important when a
 * retake, delete, logout, or deadline aborts a job before it reaches fetch.
 */
export function requestImageUploadPermit(token) {
  let resolve;
  const ticket = {
    token,
    granted: false,
    cancelled: false,
    resolve: null,
  };
  const promise = new Promise((resolvePromise) => {
    resolve = resolvePromise;
  });
  ticket.resolve = resolve;
  waiters.push(ticket);
  grantNext();

  return {
    promise,
    cancel() {
      if (ticket.cancelled) return;
      ticket.cancelled = true;
      if (activeTicket === ticket) {
        activeTicket = null;
        grantNext();
        return;
      }
      removeWaiter(ticket);
      ticket.resolve(false);
    },
  };
}

export function __resetImageUploadPermitForTests() {
  if (activeTicket) {
    activeTicket.cancelled = true;
    activeTicket = null;
  }
  while (waiters.length) {
    const ticket = waiters.shift();
    ticket.cancelled = true;
    ticket.resolve(false);
  }
}
